import { render, staticRenderFns } from "./fileUpload.vue?vue&type=template&id=0ddfdfb7&scoped=true"
import script from "./fileUpload.vue?vue&type=script&lang=js"
export * from "./fileUpload.vue?vue&type=script&lang=js"
import style0 from "./fileUpload.vue?vue&type=style&index=0&id=0ddfdfb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddfdfb7",
  null
  
)

export default component.exports